import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { colors, Button, Grid } from '@mui/material';
import { FilePicker } from 'components';
import { enqueueSnackbar } from 'actions';
import ModalDialog from '../../../../../../../components/ModalDialog/ModalDialog.js';
import { SetFormState, UploadAttachment, ToggleAttachFileIncidentTrackerDialog } from '../../../../../actions/IncidentTrackerActions';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 960,
	},
	header: {
		padding: theme.spacing(3),
		maxWidth: 720,
		margin: '0 auto',
	},
	content: {
		padding: theme.spacing(0, 2),
		maxWidth: 720,
		margin: '0 auto',
	},
	helperText: {
		textAlign: 'right',
		marginRight: 0,
	},
	author: {
		margin: theme.spacing(4, 0),
		display: 'flex',
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	actions: {
		backgroundColor: colors.grey[100],
		padding: theme.spacing(2),
		display: 'flex',
		alignContent: 'right',
	},
	applyButton: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const IncidentTrackerAddFileDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.incidentTrackerDemoReducer.formState);
	const userId = useSelector(state => state.session.user.id);

	const _onChangeInput = (event) => {
		if (event.target.files[0].type === 'image/jpeg' || event.target.files[0].type === 'image/png'
			|| event.target.files[0].type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
			|| event.target.files[0].type === 'application/pdf') {
			if (event.target.files && event.target.files.length > 0) {
				const file = event.target.files[0];
				setFormState({
					...formState,
					values: {
						...formState.values,
						inputFilePath: file
					}
				});
			}
		} else {
			dispatch(enqueueSnackbar({ message: 'File type not supported', options: { variant: 'warning' } }));
		}
	};

	const _addAttachmentFile = (event) => {
		if (formState.values.inputFilePath === '' || formState.values.inputFilePath === undefined) {
			dispatch(enqueueSnackbar({ message: 'No file selected', options: { variant: 'Info' } }));
		} else if (formState.values.inputFilePath.size > 50000000) {
			dispatch(enqueueSnackbar({ message: 'File size cannot be superior to 50MB', options: { variant: 'warning' } }));
		} else {
			dispatch(UploadAttachment(userId, formState.values.id, formState.values.inputFilePath));
			dispatch(ToggleAttachFileIncidentTrackerDialog(false));
			dispatch(enqueueSnackbar({ message: 'File uploaded', options: { variant: 'info' } }));
			setFormState({
				...formState,
				values: {
					...formState.values,
					hasAttachment: true
				}
			});
		}
	};

	return (
		<ModalDialog
			// maxWidth="xs"
			onClose={onClose}
			open={open}
			title="Add Attachment File"
			// confirmLabel="Ok"
			hasConfirm={false}
		// onConfirmClicked={_onConfirmClick}
		>
			<div className={classes.fields}>
				{/* New row */}
				<Grid container spacing={3}>
					<Grid item md={1} xs={1} />
					<Grid item md={8} xs={8}>
						<FilePicker
							placeholder="Please select a image to upload"
							accept=".jpg, .png, .pptx, .pdf"
							onChange={_onChangeInput}
							value={formState.values.inputFilePath?.name || ''}
						/>
					</Grid>
					<Grid item md={1} xs={1}>
						<Button
							color="primary"
							onClick={_addAttachmentFile}
							variant="contained"
							style={{ width: '100%', height: '100%' }}
						>
							Upload
						</Button>
					</Grid>
				</Grid>

			</div>
		</ModalDialog>
	);
};

IncidentTrackerAddFileDialog.propTypes = {
	author: PropTypes.object.isRequired,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
};

export default IncidentTrackerAddFileDialog;
